import React, { useContext, useEffect, useState } from 'react';
import { useTheme } from '@material-ui/core/styles';
import { Tabs, Tab } from './AppDrawer.styles';
import { NAV_LINKS } from '../AppLayout.constants';
import { DeleteSweep as DeleteSweepIcon } from '@material-ui/icons';
import idb from 'services/idb.service';
import { useAppContext } from 'App.context';
import { isProdEnv, determineEnv } from 'services/apiEnv.service';
import { user } from 'services/auth.service';
import { UserContext } from 'context/User.context';
import { PERMISSIONTYPES, useMe } from 'api/user';
import { DEPARTMENTS } from 'components/WizardTypes/Wizard.types';
import useGetFeatureToggle from 'hooks/useGetFeatureToggle';
import useGetFeature from 'services/useGetFeature';

interface INavLinks {
  isOpen: boolean;
  navTabIdx: number;
  handleChange: () => void;
  handleDrawerToggle?: () => void;
  hasAdminRole?: boolean;
  userPMAdminOrAdmin?: boolean;
  adminPermission?: boolean;
}

const UtilityButtons = ({ isOpen, theme }) => {
  const { setIsClientStorageReload } = useAppContext();

  return (
    <div>
      <Tab
        icon={
          <div style={{ display: 'flex', margin: 0 }}>
            <DeleteSweepIcon style={{ width: 20, height: 20 }} />
          </div>
        }
        label={
          <div style={{ textTransform: 'none', marginLeft: theme.spacing(2) }}>
            {isOpen && 'Clear Client Storage'}
          </div>
        }
        onClick={() => {
          setIsClientStorageReload(true);
          localStorage.clear();
          idb.clear().then(() => {
            window.location.reload();
          });
        }}
      />
    </div>
  );
};

const NavLinks: React.FC<INavLinks> = ({ isOpen, navTabIdx, handleChange, handleDrawerToggle }) => {
  const theme = useTheme();
  const useMeQuery = useMe();
  const userContext = useContext(UserContext);
  const customerCentricFeatureToggle = useGetFeatureToggle(determineEnv(), 56);
  const isCustomerCentricEnabled =
    customerCentricFeatureToggle?.data?.['arc_features'][0]['arc_features_arc_feature_toggles'][0][
      'is_enabled'
    ];
  const { listOfFeatures } = useGetFeature();
  const newDashboardFeature = !!listOfFeatures.find(
    feature => feature.name === 'arc new dashboard feature'
  );
  const [organizationPermission, setOrganizationPermission] = useState(false);
  const [userPMAdminOrAdmin, setUserPMAdminOrAdmin] = useState(false);
  const [teamPlannerAccess, setTeamPlannerAccess] = useState(false);
  const [taskTemplatesAccess, setTaskTemplatesAccess] = useState(false);

  useEffect(() => {
    if (userContext?.generalPermissions?.permissions) {
      setTaskTemplatesAccess(
        userContext?.generalPermissions?.permissions?.includes(PERMISSIONTYPES.EditTaskTemplates)
      );
      setOrganizationPermission(
        userContext?.generalPermissions?.permissions?.includes(PERMISSIONTYPES.OrganizationAccess)
      );
      setUserPMAdminOrAdmin(
        userContext?.generalPermissions?.permissions?.filter(
          (permission: any) =>
            permission === PERMISSIONTYPES.ViewIntakePage ||
            (permission === PERMISSIONTYPES.SteeringCommitteeGovernanceTab &&
              useMeQuery?.data?.departmentId === DEPARTMENTS?.CorporateApplications)
        ).length > 0
      );
      setTeamPlannerAccess(
        userContext?.generalPermissions?.permissions?.includes(PERMISSIONTYPES.TeamPlannerAccess)
      );
    }
  }, [userContext?.generalPermissions]);

  return (
    <div
      style={{
        height: '100vh',
        paddingTop: 52,
        display: 'flex',
        flexDirection: 'column'
      }}
    >
      <Tabs
        orientation="vertical"
        indicatorColor="primary"
        value={navTabIdx}
        onChange={handleChange}
      >
        {NAV_LINKS.map(el => (
          <Tab
            key={el.displayName}
            data-cy={`app-drawer-${el.name}`}
            icon={
              <div
                style={{
                  display: 'flex',
                  margin: 0
                }}
              >
                {el.icon}
              </div>
            }
            label={
              <div style={{ textTransform: 'none', marginLeft: theme.spacing(2) }}>
                {isOpen && el.displayName}
              </div>
            }
            onClick={() => {
              handleDrawerToggle?.();
            }}
            style={{
              display:
                el.name === 'intake-governance'
                  ? userPMAdminOrAdmin && user?.department !== 'Branding'
                    ? 'flex'
                    : 'none'
                  : el.displayName === 'Admin'
                  ? organizationPermission || taskTemplatesAccess
                    ? 'flex'
                    : 'none'
                  : el.name === 'team-planner'
                  ? teamPlannerAccess
                    ? 'flex'
                    : 'none'
                  : el.displayName === 'Team Dashboard'
                  ? isCustomerCentricEnabled || newDashboardFeature
                    ? 'flex'
                    : 'none'
                  : 'flex'
            }}
          />
        ))}
      </Tabs>

      {!isProdEnv && <UtilityButtons isOpen={isOpen} theme={theme} />}
    </div>
  );
};

export default NavLinks;
